export default __webpack_public_path__ + "static/media/1948.c7cb752b.png";